import {TextField} from "@mui/material";
import React from "react";

export function Form_TextField(props) {
    const {item, localFormState, setLocalFormState, key} = props;
    const { inputSize = "normal", defaultValue = '' } = item;
    console.warn(`InputSize ${inputSize} props ${JSON.stringify(item)}`);
    React.useEffect(() => {
        if (defaultValue !== ''){
            // localFormState[item.key] === undefined
            setLocalFormState({
                ...localFormState,
                [item.key]: defaultValue
            });
        }
    }, []);

    return (<>
        <TextField
            // key={key||"H"}
            fullWidth={true}
            label={item.label}
            helperText={item.helperText}
            // variant={"contained"}
            variant="outlined"
            size={inputSize}
            autoFocus={item.autoFocus || undefined}
            required={ item.required || false }
            type={ (item.textType === undefined) ? 'text': item.textType }
            disabled={ item.disabled === undefined ? false : item.disabled }
            steps={ item.inputSteps === undefined ? undefined : item.inputSteps }
            min={ item.inputMin === undefined ? undefined : item.inputMin }
            max={ item.inputMax === undefined ? undefined : item.inputMax }
            value={(localFormState[item.key] === null || localFormState[item.key] === undefined) ? defaultValue : localFormState[item.key]}
            onChange={
                (e) => {
                    // submit new state to the upper system
                    if (item.inputMin !== undefined && item.inputMax !== undefined){
                        if (e.target.value > item.inputMax) {
                            setLocalFormState({
                                ...localFormState,
                                [item.key]: item.inputMax
                            });
                        } else if (e.target.value < item.inputMin) {
                            setLocalFormState({
                                ...localFormState,
                                [item.key]: item.inputMin
                            });
                        }
                        else {
                            setLocalFormState({
                                ...localFormState,
                                [item.key]: e.target.value
                            });
                        }
                    } else {
                        setLocalFormState({
                            ...localFormState,
                            [item.key]: e.target.value
                        });
                    }


                }
            }
        />
    </>);
}